export default __webpack_public_path__ + "static/media/wallet-preview-account.ea130645.png";